import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { Location } from '@angular/common';

import { TablaDataSource, TablaItem } from './tabla-datasource';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss']
})

export class AdministrationComponent implements AfterViewInit, OnInit {

  username: string;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<TablaItem>;
  dataSource: TablaDataSource;

  constructor(private _location: Location) { }

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  stbDisplayedColumns = ['number', 'event', 'date', 'seeDownload'];
  technicalTeamDisplayedColumns = ['number', 'event', 'date', 'seeDownload'];

  get displayedColumns(): string[] {
    if (this.username === 'stb') {
      return this.stbDisplayedColumns;
    } else
      if (this.username === 'technicalTeam') {
        return this.technicalTeamDisplayedColumns;
      } else {
        return this.stbDisplayedColumns;
      }
  }

  ngOnInit(): void {
    this.dataSource = new TablaDataSource();
    this.username = localStorage.getItem('username');
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.table.dataSource = this.dataSource;
  }

  goBack() {
    this._location.back();
  }

  search(){
  }

}


